export const getInmobiliaria = (id)=> {
    let inmobiliaria;
    if (Number(id) === 1) {
        inmobiliaria = "Aledra";
    } else if (Number(id) ===2) {
        inmobiliaria = "Comerdesa";
    } else if (Number(id) === 3) {
        inmobiliaria = "Otros";
    }

    return inmobiliaria;
};